export default "__VITE_ASSET__Dhhkr8Ml__"